<template>
  <div class="oil-list-wrapper">
    <div class="oil-list">
      <div
        class="oil-list-item"
        v-for="item in list"
        :key="item.id"
        @click="goDetail(item.id)"
      >
        <div class="oil-logo">
          <img :src="item.mainImage" alt="" />
        </div>
        <div class="oil-detail">
          <div class="oil-detail-info">
            <div
              class="oil-detail-title"
              v-html="item.name.replace(/(\r\n|\n|\r)/, '<br />')"
            ></div>
            <div class="oil-detail-spec">规格：{{ item.volume }}</div>
          </div>
          <div class="oil-detail-extra">
            <div class="oil-detail-price">
              ￥{{ item.price
              }}<span style="font-size: 12px;margin-left: 5px"
                >元/{{ item.unitName }}</span
              >
            </div>
            <div class="oil-detail-action">
              <Icon
                slot="icon"
                style="font-size: 15px;"
                type="iconxingzhuang7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-model="show1"
      title="操作提示"
      confirm-text="前去激活"
      @on-confirm="onConfirm1"
    >
      <p style="text-align:center;">请先激活用户</p>
    </confirm>
  </div>
</template>
<script>
import { getProductList } from "@/api/goods";
import bus from "@/utils/bus/bus";
export default {
  data() {
    return {
      list: [],
      show1: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.fetchList();
  },
  mounted() {
    bus.$on("refreshList", () => {
      this.list = [];
      this.fetchList();
    });
  },
  methods: {
    onConfirm1() {
      this.$router.push("/profile");
    },
    goDetail(id) {
      this.$router.push("/order/buy/" + id);
      // if (this.userInfo.active == false) {
      //   this.$router.push("/order/buy/" + id);
      // } else {
      //   this.show1 = true;
      // }
    },
    fetchList() {
      getProductList().then(res => {
        this.list = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.oil {
  &-list {
    padding: 0 30px 30px;
    &-wrapper {
      height: 100%;
      overflow: auto;
    }
  }
  &-list-item {
    margin-top: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(186, 210, 234, 0.3);
    border-radius: 14px;
    display: flex;
  }
  &-logo {
    flex: none;
    margin-right: 30px;
    img {
      display: block;
      height: 140px;
      width: 140px;
    }
  }
  &-detail {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    &-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 1em;
      color: rgba(17, 17, 17, 1);
    }
    &-spec {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
    &-extra {
      display: flex;
      justify-content: space-between;
    }
    &-price {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 54, 0, 1);
    }
    &-action {
      width: 50px;
      height: 50px;
      background: rgba(246, 246, 246, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>
